import React, { useState } from 'react';
import DownloadDatasetModal from 'components/Dataset/DownloadDatasetModal/Container';
import DownloadTrigger from 'components/Dataset/DownloadDatasetModal/Trigger/Component';

const DownloadDataset = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <DownloadDatasetModal isOpen={isOpen} onCloseModal={closeModal} />
      <DownloadTrigger onOpenModal={openModal} />
    </>
  );
};

export default DownloadDataset;
